import * as React from "react";
import { cn } from "~/lib/utils";

export interface NavItemProps {
  title: string;
  subtext: string;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  badge?: string;
  as?: React.ElementType;
  className?: string;
  [key: string]: unknown;
}

function NavItem({ title, subtext, selected = false, onClick, disabled = false, badge, as: Comp = "button", className, ...rest }: NavItemProps) {
  // aria-pressed is only valid on actual buttons — links use aria-current instead.
  const selectionProps =
    Comp === "button" ? { type: "button", "aria-pressed": selected } : { "aria-current": selected || undefined };
  return (
    <Comp
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      aria-disabled={disabled || undefined}
      {...selectionProps}
      className={cn(
        "flex w-[140px] shrink-0 flex-col items-start gap-0 rounded-md border-[0.5px] p-2 text-left transition-colors",
        disabled && "cursor-not-allowed opacity-50 border-transparent",
        !disabled && selected && "border-border-bold",
        !disabled && !selected && "border-border hover:bg-subnav-item-hover",
        className,
      )}
      {...rest}
    >
      <span className="font-display text-text-body text-xs leading-[18px] font-bold">{title}</span>
      <span className="text-text-body-alt text-xs leading-[18px]">{subtext}</span>
      {badge && <span className="text-text-body-alt text-[11px] leading-[16px] italic">{badge}</span>}
    </Comp>
  );
}

export { NavItem };
